import { useEffect, useState } from "react";
import "./Navbar.css";
import { Link } from "react-router";
import logo from "../../../assets/images/logo.png";
import contactIcon from "../../../assets/icons/contact.svg";
import rightArrowIcon from "../../../assets/icons/rightArrow.svg";
import langSwitcherIcon from "../../../assets/icons/langSwitcher.svg";
import { useTranslation } from "react-i18next";
import applyLanguageToDocument from "../../../utils/shared/applyLanguageToDocument";

function Navbar() {
  const { t, i18n } = useTranslation("layout");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    applyLanguageToDocument(i18n.language);
  }, [i18n.language]);

  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
    applyLanguageToDocument(lang);
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className={menuOpen ? "nav-menu-open" : ""}>
      <div className="container">
        <div className="nav-brand">
          <Link to="/" onClick={closeMenu}>
            <img className="nav-logo" src={logo} alt="" />
          </Link>
        </div>

        <button
          type="button"
          className="nav-burger"
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <span />
          <span />
          <span />
        </button>

        <div className="nav-menu">
          <div className="nav-links">
            <Link className="nav-link" to="/" onClick={closeMenu}>
              {t("nav.home")}
            </Link>
            <Link className="nav-link" to="/about" onClick={closeMenu}>
              {t("nav.about")}
            </Link>
            <Link className="nav-link" to="/reference" onClick={closeMenu}>
              {t("nav.refrences")}
            </Link>
            <Link className="nav-link" to="/products" onClick={closeMenu}>
              {t("nav.products")}
            </Link>
            <Link className="nav-link" to="/services" onClick={closeMenu}>
              {t("nav.services")}
            </Link>
            <Link className="nav-link" to="/news" onClick={closeMenu}>
              {t("nav.news")}
            </Link>
            <Link className="nav-link" to="/partners" onClick={closeMenu}>
              {t("nav.partners")}
            </Link>
          </div>
          <div className="nav-actions">
            <Link className="nav-link contact-link" to="/contact" onClick={closeMenu}>
              <img src={contactIcon} alt="" />
              <img className="nav-contact-arrow" src={rightArrowIcon} alt="" />
            </Link>
            <button
              type="button"
              className="langSwitcher"
              onClick={() => changeLang(i18n.language === "EN" ? "AR" : "EN")}
            >
              <img src={langSwitcherIcon} alt="" />
              {i18n.language === "EN" ? "AR" : "EN"}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
